var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import { isValidElementType } from 'react-is';
import styled from 'styled-components';
import { borderStyle, boxStyle, flexItemStyle, gridItemStyle, responsiveMarginStyle, responsivePaddingStyle, responsiveRadiusStyle, responsiveShadowStyle } from '../../styles';
import { ThemeColorProvider, useRootTheme } from '../../theme';
import { card } from './styles';
var Root = styled.div(boxStyle, borderStyle, gridItemStyle, flexItemStyle, responsiveMarginStyle, responsivePaddingStyle, responsiveRadiusStyle, responsiveShadowStyle, card);
export var Card = forwardRef(function (props, ref) {
  var asProp = props.as,
      _props$display = props.display,
      display = _props$display === void 0 ? 'block' : _props$display,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 0 : _props$margin,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 0 : _props$padding,
      _props$radius = props.radius,
      radius = _props$radius === void 0 ? 0 : _props$radius,
      scheme = props.scheme,
      _props$tone = props.tone,
      toneProp = _props$tone === void 0 ? 'default' : _props$tone,
      restProps = __rest(props, ["as", "display", "margin", "padding", "radius", "scheme", "tone"]);

  var as = isValidElementType(asProp) ? asProp : 'div';
  var rootTheme = useRootTheme();
  var tone = toneProp === 'inherit' ? rootTheme.tone : toneProp;
  return React.createElement(ThemeColorProvider, {
    scheme: scheme,
    tone: tone
  }, React.createElement(Root, Object.assign({
    "data-scheme": rootTheme.scheme,
    "data-ui": "Card",
    "data-tone": tone
  }, restProps, {
    as: as,
    display: display,
    margin: margin,
    padding: padding,
    radius: radius,
    ref: ref,
    tone: tone
  })));
});
Card.displayName = 'Card';